function cleanReview(review) {
  if (!review || !review.summary) {
    return review;
  }
  // strip out \r's until a new version of 16+ is released
  // see https://github.com/facebook/react/issues/11103
  // Should we be styling newlines something differently here so that newlines are preserved in output?
  return {
    ...review,
    summary: review.summary.replace(/\r\n/g, '\n')
  };
}
/**
 * [cleanReviews description]
 * @param  {Array} reviews
 * @return {Array}         Reviews list with summary text cleaned of newlines.
 */
export default function cleanReviews(reviews) {
  return reviews ? reviews.map(cleanReview) : reviews;
}
